import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const NotFoundPage = () => (
  <main className="pk-page">
    <SEO
      title="Page not found"
      description="This page doesn't exist or has moved."
      noindex
    />
    <div className="pk-container pk-container--narrow">
      <header className="pk-head pk-head--center">
        <p className="pk-muted" style={{ margin: '0 0 12px', fontWeight: 500 }}>
          404
        </p>
        <h1 className="pk-head__title">Page not found</h1>
        <p className="pk-head__sub">
          The page you're looking for doesn't exist or has moved. Check the
          address, or carry on from one of these.
        </p>
        <div className="pk-head__actions">
          <Link className="pk-btn pk-btn--primary" to="/">
            Go home
          </Link>
          <Link className="pk-btn pk-btn--secondary" to="/products">
            Browse projects
          </Link>
        </div>
      </header>
    </div>
  </main>
);

export default NotFoundPage;
